<template>
    <div class="header_card">
        <ul class="menu_card">
            <li class="item_card">
                <router-link :to="{ name: 'smartCard' }" class="link_card" exact-active-class="active">{{ lang.nav_my_cards }}</router-link>
            </li>
            <li class="item_card">
                <router-link v-if="premiumProfile" :to="{ name: 'minisite' }" class="link_card" exact-active-class="active">{{ lang.nav_mini_site }}</router-link>
                <a class="link_card disabled" v-else>{{ lang.nav_mini_site }}</a>
            </li>
            <li class="item_card">
                <router-link v-if="premiumProfile" :to="{ name: 'emailSignature' }" class="link_card" exact-active-class="active">{{ lang.nav_email_signature }}</router-link>
                <a class="link_card disabled" v-else>{{ lang.nav_email_signature }}</a>
            </li>
            <li class="item_card">
                <router-link :to="{ name: 'bSiteSetting' }" class="link_card" exact-active-class="active"><i class="fa fa-cog fa-lg"></i></router-link>
            </li>
            <li class="item_card" v-if="langUpdate">
                <menuLangApp :langUpdate="langUpdate" @saveLang="ChangeLang($event)"/>
            </li>
        </ul>
    </div>
</template>
<script>
import menuLangApp from '@/core/components/Header/menuLangApp.vue';
import { mapGetters } from "vuex";
export default {
    components: {
        menuLangApp,
    },
    data() {
        return {
            isDisabled: false,
            premiumProfile: false,
            planesPro: [6, 7, 10, 11, 12],
            planActual: 1,
            lang: {
                nav_my_cards: '',
                nav_mini_site: '',
                nav_email_signature: '',
            },
            langUpdate: null,
        };
    },
    created() {
        let t = this;
        t.premiumProfile = (t.$store.getters['core/apps/getPlanIdApp'] != 8);
        t.planActual = t.$store.getters['core/apps/getPlanIdApp'];
        if(t.planActual==7){
            t.premiumProfile = true;
        }
        t.lang = t.$store.getters['ModApps/Marketea/lang'];
        t.langUpdate = t.$store.getters['ModApps/Marketea/get_langUpdate'];
        this.pullLang();
    },
    methods: {
        ChangeLang(lang) {
            // console.log('change lang', lang);
            this.$store.commit('ModApps/Marketea/set_langApp', lang);
            this.pullLang(lang);
        },
        pullLang(lang) {
            let urlService = 'bSite/pullLang'// setInfo
            let dataSend = {
                user_id: window.master_client,
                org_id: window.localorgdata,
            }
            if(lang != undefined){
                dataSend.lang = lang;
            }
            window.master.post(urlService, dataSend)
            .then((response) => {
                console.log(urlService, response.data);
                if(response.data.lang && this.langUpdate != response.data.lang){
                    this.langUpdate = response.data.lang;
                    this.$store.commit('ModApps/Marketea/set_langApp', response.data.lang);
                }
            })
            .catch((error) => {
                console.log(error);
            });
        }
    },
    computed: {
        ...mapGetters("ModApps/Marketea", { get_langUpdate: "get_langUpdate", langGetter: "lang" }),
    },
    watch: {
        get_langUpdate(newLang) {
            this.langUpdate = newLang;
        },
        langGetter() {
            this.lang = this.$store.getters['ModApps/Marketea/lang'];
        },
    }
}
</script>
